import React, { useState } from "react";

import PropTypes from "prop-types";
import RedirectModal from "./RedirectModal";
import isEmpty from "lodash/isEmpty";
import useGenericToastify from "@app/hooks/useGenericToastify";
import useWindowWidth from "@app/hooks/useWindowResize";
import { useTranslation } from "react-i18next";

const AdvancedListViewItem = ({
  item,
  previewUrl,
  favorite,
  handleFavorite
}) => {
  const { t } = useTranslation();
  const mobileBreakpoint = 768;
  const isMobile = useWindowWidth() < mobileBreakpoint;

  return (
    <>
      <li
        className={`card ${
          favorite ? "favorite col-xs-5" : "col-xs-6"
        } col-md-3`}
      >
        <a href={previewUrl} target="_blank" tabIndex={-1}>
          <picture className="card__cover">
            <img
              src={
                item.thumbnail ? item.thumbnail : "/static/images/no_image.png"
              }
              alt={t("cms.plugins.search.objectThumbnail")}
            />
          </picture>
        </a>
        {favorite && !isMobile && (
          <div
            onClick={() => handleFavorite(item.identifier, item?.is_liked)}
            role="button"
            className="heart"
          >
            <i
              className={`${
                item?.is_liked ? "fas" : "far"
              } fa-heart plugin-digital-item-rating-display__heart__icon`}
            />
          </div>
        )}
      </li>
      <li className="card col-xs-6 col-md-9">
        <div className="card__content">
          {!item.mbc && <p className="card__date">{item.catalog}</p>}
          <a
            href={!item.mbc ? item.link : previewUrl}
            target="_blank"
            className="card__title"
          >
            {item.title}
          </a>
          <p className="card__description">{item.authors}</p>
          <div className="search__info">
            {Array.isArray(item.marc21_values)
              ? item.marc21_values.map(({ key, value }, index) => (
                  <p key={`im-${index}`}>
                    <span>{key}</span>
                    <strong>{value}</strong>
                  </p>
                ))
              : ""}
          </div>
          <div className="search__info">
            {!isEmpty(item.text) ? (
              <p>
                <span>{t("cms.plugins.results.labels.ocr")}: </span>
                <strong dangerouslySetInnerHTML={{ __html: item.text }} />
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
      </li>
      {favorite && isMobile && (
        <li className={`card col-xs-1`}>
          <div
            onClick={() => handleFavorite(item.identifier, item?.is_liked)}
            role="button"
            className="heart"
          >
            <i
              className={`${
                item?.is_liked ? "fas" : "far"
              } fa-heart plugin-digital-item-rating-display__heart__icon`}
            />
          </div>
        </li>
      )}
    </>
  );
};
const AdvancedListView = ({
  items,
  urls,
  isDownloading,
  redirectParams,
  favorite,
  handleFavorite
}) => {
  const { notifyError } = useGenericToastify();

  const [resourceData, setResourceData] = useState(false);
  const onClicked = (item, e = false) => {
    if (!e || e.key === "Enter") {
      setResourceData({
        catalog: item.catalog,
        link: item.link
      });
    }
  };
  return (
    <ul className="grid search__grid">
      {items.map(item => {
        const previewUrl = `${urls.detailViewUrl}${item.slug}?${
          item?.annotation_id !== ""
            ? `annotation_id=${item.annotation_id}`
            : ""
        }${
          item?.page_number ? `&page=${item.page_number}` : ""
        }${redirectParams}`;
        return (
          <AdvancedListViewItem
            key={`lv-${item.id}`}
            item={item}
            previewUrl={previewUrl}
            favorite={favorite}
            handleFavorite={handleFavorite}
          />
        );
      })}
    </ul>
  );
};

AdvancedListView.propTypes = {
  items: PropTypes.array.isRequired,
  urls: PropTypes.object.isRequired,
  isDownloading: PropTypes.bool,
  redirectParams: PropTypes.string,
  favorite: PropTypes.bool,
  handleFavorite: PropTypes.func
};

AdvancedListView.defaultProps = {
  isDownloading: false,
  redirectParams: "",
  favorite: false,
  handleFavorite: () => {}
};

export default AdvancedListView;
